<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="slmQuantityForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                SLM
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Add SLM Quantity
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                SLM
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Edit SLM Quantity
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                SLM
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Delete SLM Quantity
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Issue Date</mat-label>
                                    <input type="date" class="color" matInput formControlName="slmIssueDate"
                                        placeholder="Issue Date" required readonly>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>SLM Quantity</mat-label>
                                    <input type="input" class="color" matInput formControlName="slmQuantity"
                                        placeholder="SLM Quantity" required>
                                    <mat-error class="margin_tp"
                                        *ngIf="slmQuantityForm.controls['slmQuantity'].touched && slmQuantityForm.controls['slmQuantity'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                    <mat-error class="margin_tp"
                                        *ngIf="slmQuantityForm.controls['slmQuantity'].touched && slmQuantityForm.controls['slmQuantity'].errors?.pattern">
                                        Invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Remark</mat-label>
                                    <input class="color" matInput formControlName="slmRemark" placeholder="Remark">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Save" type="button" *ngIf="submitButton"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="submitRecord()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1" (click)="backPage()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    Back
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>